import { useAtomValue } from 'jotai'
import { dictionaryState } from '../stores/dictionary.store'
import { languageState } from '../stores/language.store'

// Map language code to locale (dictionary key)
const CODE_TO_LOCALE: Record<string, string> = {
    EN: 'en',
    AR: 'ar',
    DE: 'de',
    ES: 'es',
    FR: 'fr',
    JP: 'ja',
    KM: 'km',
    KR: 'ko',
    TH: 'th',
    VN: 'vi',
    ZH: 'zh',
    CH: 'cn'
}

export function useTranslate() {
    const dictionaries = useAtomValue(dictionaryState)
    const language = useAtomValue(languageState)

    const translate = (word: string) => {
        // Convert language code to locale for dictionary lookup
        const locale = CODE_TO_LOCALE[language.toUpperCase()] || language.toLowerCase()
        const targetDict = dictionaries[locale]

        // If target language dictionary has the word, use it
        if (targetDict && Object.keys(targetDict).length > 0 && targetDict[word]) {
            return targetDict[word]
        }

        // If target dictionary is empty/not loaded, fallback to any loaded dictionary (except en)
        // This keeps showing the previous language while new one is loading
        if (!targetDict || Object.keys(targetDict).length === 0) {
            for (const [key, dict] of Object.entries(dictionaries)) {
                if (key !== 'en' && dict && typeof dict === 'object' && Object.keys(dict).length > 0) {
                    const value = (dict as Record<string, string>)[word]
                    if (value) {
                        return value
                    }
                }
            }
        }

        // Fallback to English
        const enDict = dictionaries['en']
        if (enDict && enDict[word]) {
            return enDict[word]
        }
        return word
    }

    const t = (word: string) => {
        return translate(word)
    }

    return { translate, t }
}
